import { ReactNode } from "react";
import { Link, Route } from "react-router-dom";
import Layout from "../layout/Layout";
import ReportPage from "../pages/ReportPage";
import { LogoutOutlined } from "@ant-design/icons";
import { AuthHelper } from "../core/helper/AuthHelper";
import PawPrintIcon from "../icon/PawPrintIcon";

export const getPrivateRoutes = () => {
  return <>{getRoute(<ReportPage />, "/")}</>;
};

const getRoute = (component: ReactNode, path: string) => {
  return <Route path={path} element={<Layout>{component}</Layout>} />;
};

export const getMenuItems = () => {
  return [
    {
      label: <Link to="/">Pet Listesi</Link>,
      key: "",
      icon: <PawPrintIcon />,
    },
    {
      label: <span onClick={AuthHelper.logout}>Çıkış Yap</span>,
      key: "cikis",
      icon: <LogoutOutlined />,
    },
  ];
};
